import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Funcionarios from './pages/Funcionarios';
import Usuarios from './pages/Usuarios';
import Perfil from './pages/Perfil';
import ResetPassword from './pages/ResetPassword';
import EquipoPublico from './pages/EquipoPublico';
import SupervisorDashboard from './pages/SupervisorDashboard';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/funcionarios" element={<Funcionarios />} />
        <Route path="/usuarios" element={<Usuarios />} />
        <Route path="/perfil" element={<Perfil />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />
        <Route path="/equipo/:codigo" element={<EquipoPublico />} />
        <Route path="/supervisor" element={<SupervisorDashboard />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
